const { gql } = require('@apollo/client');

export const GET_PRODUCT_DETAILS = gql`
    query productQuery($id: Int!, $companyId: Int, $storeId: Int) {
        productQuery(id: $id, companyId: $companyId, storeId: $storeId) {
            id
            posId
            companyId
            categoryId
            type
            isRecommend
            isCouponMeal
            sortOrder
            default
            customizable
            timed
            status
            availableToday
            availableDate {
                end
                start
            }
            company {
                timeZone
                config {
                    currency {
                        currencyCode
                    }
                }
            }
            storesPrice {
                prices {
                    DELIVERY
                    TAKEAWAY
                    GLOBAL_DELIVERY
                    GLOBAL_TAKEAWAY
                    DINE_IN
                }
            }
            categoryInfo {
                status
                timed
                availability {
                    date {
                        end
                        start
                    }
                    time {
                        end
                        start
                    }
                    day {
                        days
                    }
                }
            }
            default
            name {
                ar
                en
            }
            description {
                ar
                en
            }
            price
            marketPrice
            defaultSalesPrice
            preOrderingTiming
            image
            url
            services
            productModGroups {
                id
                posId
                quantity
                modGroupType
                status
                modGroupName {
                    ar
                    en
                }
                modifiers {
                    id
                    posId
                    foodType
                    status
                    sortOrder
                    tags
                    price
                    modItemName {
                        ar
                        en
                    }
                    description {
                        ar
                        en
                    }

                    defaultSalesPrice
                    image
                }
            }
        }
    }
`;
